import { IApiError } from '@/models/apiError.model';

export const SLICE_NAME = 'pushOrder';

export interface IPushOrderState {
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: IPushOrderState = {
  isLoading: false,
  error: null,
};
